var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"top":"","color":"blue lighten-5"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({staticClass:"tw-text-sm"},'span',attrs,false),on),[_vm._v(_vm._s(_vm.clipped))])]}}])},[_c('span',{staticClass:"tw-text-black"},[_vm._v(_vm._s(_vm.item))])])
}
var staticRenderFns = []

export { render, staticRenderFns }